module.exports = __webpack_public_path__ + "static/img/amd3.875a6a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/amd3.png
// module id = heLu
// module chunks = 1